module.exports = __webpack_public_path__ + "media/summer_2024_sweepstakes/twitter-x-5d70c9d7.svg";